export default "__VITE_ASSET__BJCD5g4k__"